$( document ).ready(function() {
  if ($('.blocTableauProduct')) {
    $('.product__description').appendTo(".blocTableauProduct");
    $('.image-with-text__text-item').remove();
  }

   $('.color-swatch').hover(
            function() {
                var colorOption = $(this).data('option');
                $(this).closest('fieldset').find('legend.form__label').text('Color: ' + colorOption);
            }, 
            function() {
                $(this).closest('fieldset').find('legend.form__label').text('Color');
            }
        );
});
